import { makeStyles } from '@material-ui/core/styles'
import Tabs from 'core/elements/tabs'
import Tab from 'core/elements/tabs/Tab'
import Theme from 'core/themes/model'
import { routeManager } from 'core/utils/routes'
import React from 'react'
import ClusterPhysicalNodes from './ClusterPhysicalNodes'
import ClusterVirtualizedNodes from './ClusterVirtualizedNodes'

export enum ClusterNodesTabs {
  VIRTUALIZED_NODES = 'virtualized-nodes',
  PHYSICAL_NODES = 'physical-nodes',
}

const ClusterNodesListPage = () => {
  const classes = useStyles()
  return (
    <div className={classes.clusterNodesTabs}>
      <Tabs route={routeManager.routes.kubernetes.infrastructure.clusterNodes}>
        <Tab label="Virtualized Nodes" value={ClusterNodesTabs.VIRTUALIZED_NODES}>
          <ClusterVirtualizedNodes />
        </Tab>
        <Tab label="Physical Nodes" value={ClusterNodesTabs.PHYSICAL_NODES}>
          <ClusterPhysicalNodes />
        </Tab>
      </Tabs>
    </div>
  )
}

// CSS
const useStyles = makeStyles<Theme>((theme) => ({
  clusterNodesTabs: {
    marginTop: theme.spacing(1),
  },
}))

export default ClusterNodesListPage
